export const goalSelectionSiteCoreKeys = {
  goalSelectionTitle:
    "ProgramsAndCandidates.CreateProgramComponent.GoalSelection",
  goalNameTableColumn:
    "CreateProgramComponent.GoalSelection.GoalNameTableColumn",
  goalThemeTableColumn:
    "CreateProgramComponent.GoalSelection.GoalThemeTableColumn",
  goalDescriptionTableColumn:
    "CreateProgramComponent.GoalSelection.GoalDescriptionTableColumn",
  goalDueDateTableColumn:
    "CreateProgramComponent.GoalSelection.GoalDueDateTableColumn",
  goalStatusTableColumn:
    "CreateProgramComponent.GoalSelection.GoalStatusTableColumn",
  goalCompletionDateTableColumn:
    "CreateProgramComponent.GoalSelection.GoalCompletionDateTableColumn",
  notesTableColumn: "CreateProgramComponent.GoalSelection.NotesTableColumn",
  actionTableColumn: "CreateProgramComponent.GoalSelection.ActionTableColumn",
  addGoalButton: "CreateProgramComponent.GoalSelection.AddGoalButton",
  noGoalsAvailableMessage:
    "CreateProgramComponent.GoalSelection.NoGoalsAvailableMessage",
  goalStatusList: "CreateProgramComponent.GoalSelection.GoalStatusList",
  deleteGoalConfirmationMessage:
    "CreateProgramComponent.GoalSelection.DeleteGoalConfirmationMessage",
  goalDeletedMessage: "CreateProgramComponent.GoalSelection.GoalDeletedMessage",
};

export const addGoalSelectionSiteCoreKeys = {
  addGoalTitle: "CreateProgramComponent.GoalSelection.AddGoal",
  goalAddedToastMessage: "GoalSelection.AddGoal.GoalAddedToastMessage",
  goalUpdatedToastMessage: "GoalSelection.AddGoal.GoalUpdatedToastMessage",
  goalCompletionDate: "GoalSelection.AddGoal.GoalCompletionDate",
  goalDescription: "GoalSelection.AddGoal.GoalDescription",
  goalDueDate: "GoalSelection.AddGoal.GoalDueDate",
  goalName: "GoalSelection.AddGoal.GoalName",
  goalStatus: "GoalSelection.AddGoal.GoalStatus",
  goalTheme: "GoalSelection.AddGoal.GoalTheme",
  notes: "GoalSelection.AddGoal.Notes",
  addGoalStatusList: "GoalSelection.AddGoal.StatusList",
  editGoalButton: "GoalSelection.AddGoal.EditGoalButton",
  editGoalTitle: "GoalSelection.AddGoal.EditGoalTitle",
  viewGoalDescription: "GoalSelection.AddGoal.ViewGoalDescription",
  viewGoalNotes: "GoalSelection.AddGoal.ViewGoalNotes",
  viewGoalTitle: "GoalSelection.AddGoal.ViewGoalTitle",
  goalCompletionDateValidationMessage:
    "GoalSelection.AddGoal.GoalCompletionDateValidationMessage",
};
